/**
 * 站内通知提醒工具：Web Audio 提示音 + 浏览器桌面通知。
 * 纯副作用函数，不持有 React 状态。
 */

let audioCtx: AudioContext | null = null;

/**
 * 初始化 / 恢复 AudioContext。
 * 必须在用户手势中首次调用，否则浏览器自动播放策略会让上下文停在 suspended。
 */
export function initNoticeAudio() {
  if (!audioCtx && typeof AudioContext !== 'undefined') {
    audioCtx = new AudioContext();
  }
  if (audioCtx?.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
}

/** 播放双音「叮咚」提示音（G5 → C6），无需音频资源。 */
export function playBeep() {
  if (!audioCtx) return;
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  const ctx = audioCtx;
  const now = ctx.currentTime;
  const notes = [
    { freq: 784, at: 0 },
    { freq: 1047, at: 0.14 },
  ];
  for (const n of notes) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = n.freq;
    const t0 = now + n.at;
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.25, t0 + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.35);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + 0.4);
  }
}

/** 请求桌面通知权限。须在用户手势中调用，浏览器才会弹授权框。 */
export function requestNotifyPermission() {
  if (typeof Notification === 'undefined') return;
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
}

/** 弹出浏览器桌面通知；未授权 / 不支持时静默跳过。 */
export function showDesktopNotification(
  title: string,
  body: string,
  onClick: () => void,
) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
    return;
  }
  try {
    const n = new Notification(title, { body, icon: '/logo.png' });
    n.onclick = () => {
      window.focus();
      onClick();
      n.close();
    };
  } catch {
    // 个别环境 Notification 构造受限（如未在 https / localhost），静默忽略
  }
}
